import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            fontFamily: "Lexend, sans-serif",
            fontWeight: 500,
            border: "1px solid rgba(23, 26, 54, 0.12)",
            boxShadow: "0 12px 32px -12px rgba(23, 26, 54, 0.25)",
            borderRadius: "16px",
            background: "#FFF8EC",
            color: "#171A36",
          },
        }}
      />
    </div>
  );
}

export default App;
